export const placesAPIKey = process.env.REACT_APP_PLACES__API__KEY;
export const mapsAPIKey = process.env.REACT_APP_MAPS__API_KEY;
export const yahooAPIKey = process.env.REACT_APP_WEATHER_API_KEY;
export const geocodeAPIKey = process.env.REACT_APP_GEOCODE_API_KEY;
